var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__a",
    cx: "50.004%",
    cy: "54.676%",
    r: "71.79%",
    fx: "50.004%",
    fy: "54.676%",
    gradientTransform: "matrix(.9236 0 0 1 .038 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#F95D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.91%",
    stopColor: "#F95353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F95353"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M22.383 13.988c-3.443 0-6.223 2.777-6.223 6.217 0 3.44 2.78 6.216 6.223 6.216 3.444 0 6.224-2.777 6.224-6.216 0-3.42-2.78-6.217-6.224-6.217zm-16.16 0C2.78 13.988 0 16.765 0 20.205c0 3.44 2.78 6.216 6.223 6.216 3.444 0 6.224-2.777 6.224-6.216 0-3.42-2.8-6.217-6.224-6.217zm14.314-7.771c0 3.44-2.78 6.217-6.223 6.217-3.444 0-6.224-2.777-6.224-6.217C8.09 2.777 10.87 0 14.314 0c3.423 0 6.223 2.777 6.223 6.217z",
    transform: "translate(1.333 2.667)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsana);
export default __webpack_public_path__ + "static/media/asana.15c2d248.svg";
export { ForwardRef as ReactComponent };